import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SeasonTable from "./SeasonTable";
import { CurrentWeekTable } from "./CurrentWeekTable";
import { UpcomingWeekTable } from "./UpcomingWeekTable";
import { getSeasonLeaderBoard } from "../../../../services/leaderBoard";

const SeasonDetail = () => {
  const { seasonId } = useParams();
  const [data, setData] = useState();
  const [refetch, setRefetch] = useState(false);

  const fetchData = async () => {
    try {
      // setLoading(true);
      // setError(null);
      const response = await getSeasonLeaderBoard(seasonId);

      console.log("response season details === ", response.data.result);
      setData(response.data.result);
      // setData(
      //   response.data.joined_leagues.map((ele, idx) => ({ id: idx, ...ele }))
      // );
      // setTotalRecords(response.data.conducted_leagues.length);
    } catch (err) {
      console.log("error === ", err);
      // setError("Failed to fetch data");
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [refetch]);

  const currentWeek = data?.past_weeks?.reduce((latest, week) => {
    if (week.players) {
      return Math.max(latest, week.week);
    }
    return latest;
  }, 0);

  console.log("data check ====", data?.upcoming_week === null && data?.current_week === null && data?.past_weeks === null)
  return (
    <div>
      {data?.upcoming_week === null && data?.current_week === null && data?.past_weeks === null && <div>No data found</div>}
      {data && data.upcoming_week && (
        <UpcomingWeekTable
          data={data.upcoming_week}
          refetch={() => setRefetch((prev) => !prev)}
        />
      )}
      {data && data.current_week && (
        <CurrentWeekTable
          data={data.current_week}
          refetch={() => setRefetch((prev) => !prev)}
        />
      )}
      {data &&
        data.past_weeks &&
        data.past_weeks
          .filter((week) => week.week <= currentWeek + 1) // Only show current week and next week
          .reverse()
          .map((week) => (
            <SeasonTable
              key={week.week}
              data={{
                ...week,
                players: week.players || [], // Pass empty array for next week
              }}
            />
          ))}
    </div>
  );
};

export default SeasonDetail;
